<template>
  <UIButton
    :label
    :leading="UserMinusIcon"
    variant="danger"
    fill="light"
    :size
    @click="handleClick"
  />
</template>

<script setup lang="ts">
import { computed, markRaw } from 'vue'

import {
  RepositoryInvite,
  RepositoryCollaborator,
  ButtonSize,
} from '@types'

import { useModalsStore } from '@/store/modals'

import { UIButton } from '@ui/buttons'
import { UserMinusIcon } from '@heroicons/vue/24/outline'
import CollaboratorsButtonsRemove from './CollaboratorsButtonsRemove.vue'

type Props = {
  item: RepositoryInvite | RepositoryCollaborator
  size: ButtonSize
  currentUserId?: string
  repositoryId: string
}

const props = defineProps<Props>()

const modalsStore = useModalsStore()

const isOwnRecord = computed(
  () => props.currentUserId !== (props.item as RepositoryCollaborator).user?.id,
)

const label = computed(() => (isOwnRecord.value ? 'Remove' : 'Unlink'))

const handleClick = () => {
  const modalInstance = modalsStore.init('collaborators-buttons-remove', markRaw(CollaboratorsButtonsRemove))
  modalInstance?.open(modalsStore.getZIndex(), {
    item: props.item,
    isOwnRecord: isOwnRecord.value,
    repositoryId: props.repositoryId,
  })
}
</script>
